import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const sliderVariants = {
	enter: {
		opacity: 0,
		x: 50,
	},
	center: {
		opacity: 1,
		x: 0,
		transition: { duration: 0.6, ease: "easeOut" },
	},
	exit: {
		opacity: 0,
		x: -50,
		transition: { duration: 0.4, ease: "easeIn" },
	},
};

const comments = [
	{
		name: "Tania Aldaraca Mercadóloga, Puebla",
		date: "Jueves 17 de junio, 2021",
		comment:
			"Alquilé un auto deportivo y me enamoré del dinamismo del vehículo, pero tambien la atención fue muy buena",
	},
	{
		name: "Carlos Romero Abogado, Puebla",
		date: "Domingo 5 de Septiembre, 2025",
		comment:
			"Renté una van para llevar a un congreso a algunos de mis colaboradores, fue una muy grata experiencia de principio a fin",
	},
	{
		name: "Amanda Cuellar Nutrióloga, Tlaxcala",
		date: "Miercoles 23 de Febrero, 2022",
		comment:
			"El auto que renté durante las tres semanas que estuve en Puebla, fue muy práctico para moverme en la ciudad e incluso cuando tuve que ir a mi lugar de residencia",
	},
	{
		name: "Marcelino García Ingeniero Industrial, Puebla",
		date: "Martes 19 de Abril, 2022",
		comment:
			"Las tarifas de arrendamiento están bastante accesibles, es seguro que volveré a rentar una camioneta",
	},
];

export default function TestimonialsSection() {
	const [currentIndex, setCurrentIndex] = useState(0);
	const interval = 7000;

	useEffect(() => {
		const timer = setInterval(() => {
			setCurrentIndex((prev) => (prev + 1) % comments.length);
		}, interval);

		return () => clearInterval(timer);
	}, [interval]);

	return (
		<section className="w-full bg-[#0a1633] py-10 flex flex-col items-center px-6">
			<div className="w-full max-w-4xl border-b border-[#cbbca3]/40 pb-6 mb-12">
				<h2 className="text-[#cbbca3] text-4xl md:text-5xl font-bold text-center">
					Elogios de nuestros clientes
				</h2>
			</div>
			<div className="relative w-full max-w-4xl h-56 ">
				<motion.div
					key={currentIndex}
					variants={sliderVariants}
					initial="enter"
					animate="center"
					exit="exit"
					className="absolute w-full bg-white/5 border border-white/10 rounded-2xl p-8 shadow-lg backdrop-blur-sm"
				>
					<p className="text-sm text-gray-300 mb-1">
						{comments[currentIndex].date}
					</p>

					<p className="text-[#cbbca3] text-lg font-semibold mb-3">
						{comments[currentIndex].name}
					</p>
					<p className="text-white text-lg italic leading-relaxed">
						"{comments[currentIndex].comment}"
					</p>
				</motion.div>
			</div>
		</section>
	);
}
